import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import moment from "moment";
import { TIME_FORMAT_H24 } from "types";

export class CustomValidators {
  /**
   * Form-level validator for time ranges. Validates that start time is before end time.
   * Use this as a form validator to avoid cross-field validation issues.
   * @param startFieldName - The name of the start time field
   * @param endFieldName - The name of the end time field
   * @param errorKey - The error key to use (default: 'invalidTimeOrder')
   * @returns ValidatorFn that returns validation errors or null
   */
  static timeRangeValidator(startFieldName: string, endFieldName: string, errorKey = "invalidTimeOrder"): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const startControl = control.get(startFieldName);
      const endControl = control.get(endFieldName);

      if (!startControl || !endControl) {
        return null;
      }

      const startTime = startControl.value as string;
      const endTime = endControl.value as string;

      if (!startTime || !endTime) {
        return null;
      }

      const start = moment(startTime, TIME_FORMAT_H24);
      const end = moment(endTime, TIME_FORMAT_H24);

      if (!start.isValid() || !end.isValid()) {
        return null;
      }

      if (start.isSameOrAfter(end)) {
        return { [errorKey]: true };
      }

      return null;
    };
  }
}
